import { createSelector } from 'reselect';

import { ReduxState } from '../state';
import { UserpilotState } from './types';

export const selectUserpilot = (state: ReduxState): UserpilotState =>
  state.Userpilot;

export const selectUserpilotScriptLoaded = createSelector(
  selectUserpilot,
  (userpilot) => userpilot.scriptLoaded
);

// TODO: write a selector to check if userpilot is enabled for current user
